import { render, staticRenderFns } from "./major-list.vue?vue&type=template&id=0e19af3a&scoped=true"
import script from "./major-list.vue?vue&type=script&lang=js"
export * from "./major-list.vue?vue&type=script&lang=js"
import style0 from "./major-list.vue?vue&type=style&index=0&id=0e19af3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e19af3a",
  null
  
)

export default component.exports